import React, { useState, useEffect } from 'react';
import { Mail, Send } from 'lucide-react';

const ContactButton = () => {
  const email = 'unmapped.blr@gmail.com';
  const instagramUrl = 'https://instagram.com/unmapped.blr';
  const instagramHandle = '@unmapped.blr';
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
      }`}
    >
      {isExpanded ? (
        <div className="bg-white border-4 border-[#1A532F] rounded-2xl shadow-2xl p-6 w-80 animate-in slide-in-from-bottom duration-300">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-[#1A532F] font-bold text-lg pixel-text">
              Get in Touch
            </h3>
            <button
              onClick={() => setIsExpanded(false)}
              className="text-[#1A532F] hover:text-[#E64A2B] transition-colors"
            >
              ✕
            </button>
          </div>

          <div className="space-y-3">
            <a
              href={`mailto:${email}`}
              className="flex items-center space-x-3 text-[#1A532F] hover:text-[#E64A2B] transition-colors group"
            >
              <Mail size={20} />
              <span className="text-sm group-hover:underline">
                {email}
              </span>
            </a>

            <div className="pt-3 border-t-2 border-[#1A532F]/20">
              <p className="text-[#1A532F]/70 text-xs mb-3">Follow us:</p>
              <div className="flex">
                <a
                  href={instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center bg-[#E64A2B] hover:bg-[#F5B041] rounded-lg px-4 py-2 text-white transition-all hover:scale-105 font-bold text-sm"
                >
                  {instagramHandle}
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setIsExpanded(true)}
          className="bg-[#1A532F] hover:bg-[#E64A2B] text-white px-4 py-2.5 md:px-6 md:py-4 rounded-full shadow-2xl transition-all duration-300 hover:scale-110 flex items-center space-x-2 md:space-x-3 font-bold group text-sm md:text-base"
        >
          <Send className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" />
          <span className="pixel-text">Contact Us</span>
        </button>
      )}
    </div>
  );
};

export default ContactButton;
